import {
  CabecalhoMudarPagina,
  ContainerFundoBranco,
  ItemPreenchido,
  TextoCabecalhoMudarPagina,
  TextoCorLinkNovoPlano,
} from "../styles";
import { IconeBotao } from "../../../selecaoEmpresas/styles";
import {
  CardFooter,
  Container,
  ContainerCards,
  ContainerItemCard,
  CorpoCard,
  TituloCard,
  Linha,
  ContainerCard,
  FooterCard,
  LinhaBotoesInformacoesGerais,
  Coluna,
  ContainerAviso,
  TextoAviso,
  NomeEmpresa,
  HeaderPopup,
  TextoTitulo,
  XIcon,
  TextoNotificacoesPedido,
} from "./styles";
import {
  BotaoAzulPreenchido,
  BotaoAzulVazado,
  BotaoVerdePreenchido,
  BotaoVermelhoPreenchido,
  BotaoVermelhoSemFundo,
  BotaoVermelhoVazado,
} from "../../../../components/Botao";
import { IndicadorStatus } from "../../../../components/IndicadorStatus";
import { TabelaLib } from "../../../../components/TabelaLib";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash, faWarning } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@emotion/react";
import { Fragment, useEffect, useRef, useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { ResponseInformacoesGerais } from "../../../../services/contrato/waybe/MapperInformacoesGerais";
import formatarReal from "../../../../utils/formatarReal";
import { useApi } from "../../../../contexts/api";
import { toast } from "react-toastify";
import { formatarDataParaPadraoBrasileiro } from "../../../../utils/formatarDataPadraoBrasileiro";
import { GerarModalConfirmacao } from "../../../../components/PopUpConfirmacao";
import { CampoDeTextoBase } from "../../../../components/CampoInput/styles";
import {
  CampoDeInputNumericoComSetas,
  CampoDeSelecao,
  CampoDeTexto,
} from "../../../../components/CampoInput";
import { CampoDeInputNumerico } from "../../../../components/CampoInputSemEstado";
import { getUrlEmpresa } from "../../../../enums/TipoEmpresa";
import Carregando from "../../../carregando";
import PlanosCompra from "../../listagemPlanos/planosCompra";
import RealizarPagamento from "../../../realizarPagamento";
import { Box, Chip, CircularProgress } from "@mui/material";
import GerarModalResponsivo from "../../../../components/GerarModalResponsivo";
import { InfoOutlined, Save } from "@mui/icons-material";
import { useAuth } from "../../../../contexts/auth";
import tornarSlider from "../../../../utils/tornarSlider";
import useTamanhoTela from "../../../../utils/useTamanhoTela";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

let aplicacaoSelecionadaGlobal;
export function InformacoesGerais({ detalharPlano }) {
  const { t } = useTranslation("common");
  const { t: tPagamento } = useTranslation("pagamento");
  const PAGINA_INFORMACOES_GERAIS = "PAGINA_INFORMACOES_GERAIS";
  const PAGINA_PLANOS_DISPONIVEIS = "PAGINA_PLANOS_DISPONIVEIS";
  const PAGINA_PAGAMENTO = "PAGINA_PAGAMENTO";

  const refSlider = useRef();
  const tema = useTheme();
  const { get, put, post, del } = useApi();
  const navigate = useNavigate();
  const { pagamentoNecessario, dadosAuth } = useAuth();

  const [paginaAtiva, setPaginaAtiva] = useState(PAGINA_INFORMACOES_GERAIS);
  const [dadosPagamento, setDadosPagamento] = useState();
  const [desabilitadoSessao, setDesabilitadoSessao] = useState(false);

  const [informacoes, setInformacoes] = useState({});
  const [dadosTabela, setDadosTabela] = useState();
  const [loading, setLoading] = useState(true);
  const [possuiContratosParaCancelar, setPossuiContratosParaCancelar] = useState(false);

  useEffect(() => {
    aplicacaoSelecionadaGlobal = undefined;
  }, []);

  useEffect(() => {
    if (paginaAtiva === PAGINA_INFORMACOES_GERAIS) {
      tornarSlider(refSlider.current);
      buscarDados();
    }
  }, [paginaAtiva]);

  async function buscarDados() {
    await get("/contrato/consumidor/waybe/empresa-contrato/informacoes-gerais")
      .then((response) => {
        if (response.status === 200) {
          const data = ResponseInformacoesGerais.map(response.data);
          setInformacoes(data);
          renderizarItems(data.listaContratos, data.idEmpresaContratoWaymenu);
          setLoading(false);
        } else {
          throw new Error("Erro ao obter o contrato");
        }
      })
      .catch((error) => {
        setLoading(false);
        setInformacoes([]);
        console.error(error);
        navigate("/");
        toast.error(tPagamento("messages.contractLoadError"));
      });
  }

  function Card({ children, titulo, footer }) {
    return (
      <CorpoCard>
        <ContainerCard style={{ marginBottom: "24px", fontSize: "23px" }}>{titulo}</ContainerCard>

        <ContainerCard style={{ flex: "1" }}>{children}</ContainerCard>

        <CardFooter>{footer}</CardFooter>
      </CorpoCard>
    );
  }

  function ItemCard({ titulo, conteudo, corConteudo }) {
    return (
      <ContainerItemCard>
        <p>{titulo}</p>
        <p style={{ fontWeight: "600", color: corConteudo }}>{conteudo}</p>
      </ContainerItemCard>
    );
  }

  function ItemCardMonetario({ titulo, conteudo, corConteudo }) {
    return (
      <ContainerItemCard>
        <p>{titulo}</p>
        <p style={{ fontWeight: "600", color: corConteudo }}>{formatarReal(conteudo)}</p>
      </ContainerItemCard>
    );
  }

  function tituloCardSessoesExtras(titulo) {
    const quantidadeSessoesExtrasCanceladas =
      informacoes.sessoesExtras.quantidadeSessoesExtrasCanceladas;

    if (quantidadeSessoesExtrasCanceladas > 0)
      return tituloCardFactory(
        titulo,
        "vermelho",
        tPagamento("informationCards.cancelledRecurrences", {
          count: quantidadeSessoesExtrasCanceladas,
        }),
      );

    return tituloCard(titulo);
  }

  function tituloCardFactory(titulo, cor, textoChip) {
    if (cor && textoChip) return tituloCardComTooltip(titulo, cor, textoChip);
    else return tituloCard(titulo);
  }

  function tituloCard(titulo) {
    return <TituloCard>{titulo}</TituloCard>;
  }

  function tituloCardComTooltip(titulo, cor, textoChip) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", gap: "8px" }}>
        <TituloCard>{titulo}</TituloCard>
        <IndicadorStatus cor={cor} texto={textoChip} style={{ height: 28, maxWidth: 128 }} />
      </div>
    );
  }

  function footerCardSessao() {
    return (
      <FooterCard>
        <BotaoModalCancelarRecorrenciaExtras />
        <BotaoModalIncrementarExtras />
      </FooterCard>
    );
  }

  function irParaPagina() {}

  function buscarValoresColuna() {}

  function isPossuiContratoParaCancelar(data) {
    for (const index in data) {
      if (data[index].status.status === "PAGO") {
        return true;
      }
    }

    return false;
  }

  function renderizarItems(data, idEmpresaContratoWaymenu) {
    setPossuiContratosParaCancelar(isPossuiContratoParaCancelar(data));

    const dadosTabela = data.map((contrato, index) => mapToContrato(contrato, index));

    // // Não mostrar Linha Waymenu caso não contratado.
    // if (!idEmpresaContratoWaymenu || idEmpresaContratoWaymenu == undefined) {
    //   dadosTabela = dadosTabela.filter(
    //     (contrato) => contrato.aplicacao !== "Waymenu"
    //   );
    // }

    const novosDadosTabela = {
      mudarPagina: irParaPagina,
      valoresColuna: buscarValoresColuna,
      colunas: [
        {
          key: "aplicacao",
          titulo: tPagamento("general.myContracts"),
          esconder: false,
        },
        {
          key: "plano",
          titulo: tPagamento("general.planType"),
          esconder: false,
        },
        {
          key: "sessao",
          titulo: tPagamento("general.sessionQuantity"),
          esconder: false,
        },
        { key: "status", titulo: t("fields.status") },
        { key: "acao", titulo: t("fields.actions"), ordenacao: false },
      ],
      gridColuna: `repeat(3, minmax(250px, 1fr)) 160px 80px !important`,
      nodes: dadosTabela,
    };

    setDadosTabela(novosDadosTabela);
  }

  function mapToContrato(contrato, index) {
    const desabilitado = contrato.status.status === "NAO_CONTRATADO";
    return {
      id: contrato.idContrato,
      aplicacao: contrato.nomeAplicacao,
      plano: gerarTipoPlano(contrato, desabilitado),
      sessao: contrato.quantidadeSessoes === 0 ? "-" : contrato.quantidadeSessoes,
      status: (
        <IndicadorStatus
          cor={contrato.status.cor}
          texto={contrato.status.descricao}
          style={{ height: 28 }}
        />
      ),
      acao: <Linha>{gerarIconeOlho(desabilitado, contrato.tipoAplicacaoContrato)}</Linha>,
    };
  }

  function gerarTipoPlano(contrato, desabilitado) {
    if (desabilitado)
      return (
        <Link
          key={contrato.tipoAplicacaoContrato}
          onClick={() => {
            aplicacaoSelecionadaGlobal = contrato.tipoAplicacaoContrato;
            irParaPlanosDisponiveis();
          }}
          style={{ textDecoration: "none" }}
        >
          <TextoCorLinkNovoPlano>
            <p>{tPagamento("plan.hire")}</p>
          </TextoCorLinkNovoPlano>
        </Link>
      );
    else return contrato.tipoPlano;
  }

  function gerarIconeOlho(desabilitado, tipoAplicacaoContrato) {
    if (desabilitado || pagamentoNecessario)
      return (
        <div>
          <RemoveRedEyeIcon style={{ fill: corAzulIconeOlhoDesabilitado() }} />
        </div>
      );
    else
      return (
        <Link to="" onClick={() => detalharPlano(tipoAplicacaoContrato)}>
          <RemoveRedEyeIcon style={{ fill: corAzulIconeOlhoHabilitado() }} />
        </Link>
      );
  }

  function corVerdeDinheiro() {
    return tema.getCorTema("#1EA834", tema.cores.semanticSuccess2);
  }

  function corAzulIconeOlhoHabilitado() {
    return tema.getCorTema("#006495", "#23A0E8");
  }

  function corAzulIconeOlhoDesabilitado() {
    return "#DCE3E9";
  }

  function formatarRecorrencia(periodicidade) {
    const mapaPeriodicidade = {
      MENSAL: tPagamento("general.monthly"),
      TRIMESTRAL: tPagamento("general.quarterly"),
      SEMESTRAL: tPagamento("general.semiannual"),
      ANUAL: tPagamento("general.annual"),
    };

    return mapaPeriodicidade[periodicidade] || periodicidade;
  }

  function BotaoModalCancelarRecorrencias() {
    const [motivoCancelamento, setMotivoCancelamento] = useState("");

    function cancelarContratos(fecharModal) {
      if (pagamentoNecessario) return;
      post("/contrato/consumidor/waybe/empresa-contrato/aplicacoes/cancelar-recorrencia", {
        motivoCancelamento,
      })
        .then((response) => {
          if (response.status === 200) {
            toast.info(tPagamento("messages.contractsCancelled"));
            buscarDados();
          } else {
            toast.error(tPagamento("messages.cancelContractError"));
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error(tPagamento("messages.cancelContractError"));
        })
        .finally(() => {
          fecharModal();
        });
    }

    return (
      <GerarModalConfirmacao
        onClick={(b) => cancelarContratos(b)}
        trigger={<BotaoVermelhoVazado texto={tPagamento("general.cancelContracts")} tamanho="SM" />}
        titulo={tPagamento("general.cancelContracts")}
        subTitulo={tPagamento("general.cancelContractsConfirmation")}
        observacao={tPagamento("plan.cancelNotice")}
        botaoCancelar={(fechar) => (
          <BotaoVermelhoVazado texto={t("buttons.cancel")} tamanho="MD" onClick={fechar} />
        )}
        botaoConfirmar={(fechar) => (
          <BotaoVermelhoPreenchido
            texto={t("buttons.confirm")}
            tamanho="MD"
            onClick={() => cancelarContratos(fechar)}
          />
        )}
        campoInput={
          <CampoDeTexto
            titulo={tPagamento("general.cancelReason")}
            value={motivoCancelamento}
            onChange={(e) => setMotivoCancelamento(e.target.value)}
          />
        }
      />
    );
  }

  function BotaoModalIncrementarExtras() {
    const [quantidadeExtras, setQuantidadeExtras] = useState(1);
    const [valorTotal, setValorTotal] = useState(0);
    const [valorUnitario, setValorUnitario] = useState(0);
    const [carregando, setCarregando] = useState(true);
    const [carregandoRequisicao, setCarregandoRequisicao] = useState(false);

    function atualizarValor() {
      if (pagamentoNecessario) return;
      setCarregando(true);
      get(
        "/contrato/consumidor/waybe/empresa-contrato/item/extra/calculo/sessao-extra/" +
          quantidadeExtras,
      )
        .then((response) => {
          if (response.status === 200) {
            setValorTotal(response.data.listaItens[0].valorTotal);
            setValorUnitario(response.data.listaItens[0].valorUnitario);
          } else {
            setDesabilitadoSessao(true);
            setValorTotal(null);
            setValorUnitario(null);
          }
          setCarregando(false);
        })
        .catch((err) => {
          console.error(err);
        });
    }

    useEffect(() => {
      atualizarValor();
    }, []);

    useEffect(() => {
      atualizarValor();
    }, [quantidadeExtras]);

    function incrementarExtras(fecharModal) {
      if (pagamentoNecessario) return;
      if (carregandoRequisicao) return;
      setCarregandoRequisicao(true);
      const itemExtra = {
        tipoItemPlano: "SESSAO_EXTRA",
        quantidade: quantidadeExtras,
      };

      post("/contrato/consumidor/waybe/empresa-contrato/item/extra/por-tipo", itemExtra)
        .then((response) => {
          setCarregandoRequisicao(false);
          if (response.status === 200) {
            toast.info(tPagamento("messages.extraSessionsHired"));
            buscarDados();
          } else {
            if (response.data.message === "Nenhum cartao padrao encontrado.") {
              toast.error(tPagamento("messages.noDefaultCard"));
              return;
            }
            toast.error(tPagamento("messages.extraSessionsHireError"));
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error(tPagamento("messages.extraSessionsHireError"));
        })
        .finally(() => {
          setQuantidadeExtras(0);
          fecharModal();
        });
    }

    const styleDesabilitado = desabilitadoSessao
      ? {
          pointerEvent: "none",
          backgroundColor: tema.cores.actionDisable,
          color: tema.cores.textActionDisable,
          border: `1px solid ${tema.cores.actionDisable}`,
          cursor: "auto",
        }
      : {};

    return (
      <GerarModalConfirmacao
        disabled={desabilitadoSessao}
        trigger={
          <BotaoAzulVazado
            style={{
              ...{
                minWidth: "150px",
                padding: "0px 0px",
              },
              ...styleDesabilitado,
            }}
            texto={tPagamento("general.hireExtraSessions")}
            tamanho="SM"
          />
        }
        titulo={tPagamento("general.hireExtraSessionsTitle")}
        subTitulo={
          <div style={{ marginLeft: 16, marginTop: "-26px" }}>
            <p style={{ fontSize: 12, lineHeight: "normal", marginBottom: 24 }}>
              {tPagamento("general.extraSessionsValueNotice")}
            </p>
            <p style={{ fontSize: 16, lineHeight: "normal", marginBottom: 24 }}>
              {tPagamento("general.unitValueThirtyDays")}
              <span
                style={{
                  // fontWeight: 600,
                  marginLeft: 4,
                  // color: corVerdeDinheiro(),
                }}
              >
                {formatarReal(valorUnitario)}
              </span>
            </p>
            {tPagamento("general.extraTotalValue")}
            {carregando ? (
              <CircularProgress
                size={13}
                style={{ marginLeft: 8, fill: tema.cores.textActionSuccess }}
              />
            ) : (
              <span
                style={{
                  fontWeight: 600,
                  marginLeft: 4,
                  color: corVerdeDinheiro(),
                }}
              >
                {formatarReal(valorTotal)}
              </span>
            )}
          </div>
        }
        botaoCancelar={(fechar) => (
          <BotaoVermelhoVazado
            texto={t("buttons.cancel")}
            tamanho="MD"
            disabled={desabilitadoSessao}
            onClick={fechar}
            style={{
              minWidth: "150px",
              padding: "0px 0px",
              userSelect: "none",
            }}
          />
        )}
        botaoConfirmar={(fechar) => (
          <BotaoVerdePreenchido
            style={{
              minWidth: "150px",
              padding: "0px 0px",
              userSelect: "none",
            }}
            texto={tPagamento("plan.hire")}
            tamanho="MD"
            onClick={() => incrementarExtras(fechar)}
            icone={
              carregandoRequisicao ? (
                <CircularProgress style={{ color: "white", fill: "white" }} size={13} />
              ) : null
            }
          />
        )}
        campoInput={
          <CampoDeInputNumericoComSetas
            width="100%"
            label={tPagamento("extras.quantity")}
            style={{ userSelect: "none" }}
            value={quantidadeExtras}
            onChange={(e) => {
              setQuantidadeExtras(e);
            }}
          />
        }
      />
    );
  }

  function BotaoModalConfigurarContrato({ recorrenciaAtual, informacoesGerais }) {
    const [periodoRecorrencia, setPeriodoRecorrencia] = useState(recorrenciaAtual);
    const [periodoRecorrenciaAlterado, setPeriodoRecorrenciaAlterado] = useState(false);
    const [diaCobranca, setDiaCobranca] = useState(null);
    const [diaCobrancaAlterado, setDiaCobrancaAlterado] = useState(false);

    async function salvarConfiguracao(fechar) {
      if (pagamentoNecessario) return;

      if (periodoRecorrenciaAlterado == true) {
        await put("/pagamento/pagamento-configuracao/recorrencia/" + periodoRecorrencia)
          .then((response) => {
            if (response.status === 200) {
              toast.success(tPagamento("messages.recurrencePeriodUpdated"));
            } else {
              throw new Error(response.data);
            }
          })
          .catch((error) => {
            console.error(error);
            toast.error(
              error?.response?.data?.message
                ? error?.response?.data?.message
                : tPagamento("messages.recurrencePeriodUpdateError"),
            );
          });
      }
      if (diaCobrancaAlterado == true) {
        await put("/contrato/empresa-contrato-waybe/vencimento", {
          diaCobranca: Number(diaCobranca),
        })
          .then((response) => {
            if (response.status === 200) {
              toast.success(tPagamento("messages.billingDayUpdated"));
            } else {
              throw new Error(response.data);
            }
          })
          .catch((error) => {
            console.error(error);
            toast.error(
              error?.response?.data?.message
                ? error?.response?.data?.message
                : tPagamento("messages.billingDayUpdateError"),
            );
          });
      }
      if (periodoRecorrenciaAlterado || diaCobrancaAlterado) {
        buscarDados();
        fechar();
      }
    }

    function ChipCustomizado({ valor, titulo, onClick, valorSelecionado }) {
      return (
        <Chip
          label={
            <Box
              sx={{
                color: valorSelecionado === valor ? "white" : tema.cores.actionActive,
              }}
            >
              {titulo}
            </Box>
          }
          variant={valorSelecionado === valor ? "filled" : "outlined"}
          color="primary"
          onClick={() => onClick(valor)}
        />
      );
    }

    function alterarRecorrencia(valor) {
      setPeriodoRecorrencia(valor);
      setPeriodoRecorrenciaAlterado(true);
    }

    function alterarDiaCobranca(valor) {
      setDiaCobranca(valor);
      setDiaCobrancaAlterado(true);
    }

    function verificarContratoVencido() {
      const dataVencimento = dayjs(informacoesGerais.dataVencimentoContrato).startOf("day");
      const dataAtual = dayjs().startOf("day");

      if (dataVencimento.isBefore(dataAtual)) {
        return true;
      } else {
        return false;
      }
    }

    return pagamentoNecessario || verificarContratoVencido() ? (
      <BotaoAzulVazado disabled={true} texto={tPagamento("general.configure")} tamanho="SM" />
    ) : (
      <GerarModalResponsivo
        width={"500px"}
        trigger={
          pagamentoNecessario || verificarContratoVencido() ? (
            <></>
          ) : (
            <BotaoAzulVazado texto={tPagamento("general.configure")} tamanho="SM" />
          )
        }
        children={(fechar) =>
          pagamentoNecessario || verificarContratoVencido() ? (
            <></>
          ) : (
            <Coluna>
              <HeaderPopup>
                <TextoTitulo>{tPagamento("general.recurrencePeriod")}</TextoTitulo>
                <XIcon onClick={fechar} />
              </HeaderPopup>
              <ContainerAviso>
                <InfoOutlined
                  style={{
                    width: 20,
                    height: 20,
                    color: tema.cores.semanticAlert1,
                  }}
                />
                <TextoAviso>{tPagamento("general.recurrenceChangeNotice")}</TextoAviso>
              </ContainerAviso>

              <TextoNotificacoesPedido>
                {tPagamento("general.choosePeriod")}
              </TextoNotificacoesPedido>
              <Linha style={{ justifyContent: "flex-start" }}>
                <ChipCustomizado
                  valor={"MENSAL"}
                  valorSelecionado={periodoRecorrencia}
                  titulo={tPagamento("general.monthly")}
                  onClick={alterarRecorrencia}
                />

                <ChipCustomizado
                  valor={"TRIMESTRAL"}
                  valorSelecionado={periodoRecorrencia}
                  titulo={tPagamento("general.quarterly")}
                  onClick={alterarRecorrencia}
                />

                <ChipCustomizado
                  valor={"SEMESTRAL"}
                  valorSelecionado={periodoRecorrencia}
                  titulo={tPagamento("general.semiannual")}
                  onClick={alterarRecorrencia}
                />

                <ChipCustomizado
                  valor={"ANUAL"}
                  valorSelecionado={periodoRecorrencia}
                  titulo={tPagamento("general.annual")}
                  onClick={alterarRecorrencia}
                />
              </Linha>
              {dadosAuth.tipoLogin !== "COMUM" ? (
                <></>
              ) : (
                <>
                  <TextoNotificacoesPedido>
                    {tPagamento("general.chooseBillingDay")}
                  </TextoNotificacoesPedido>
                  <Linha style={{ justifyContent: "flex-start" }}>
                    <ChipCustomizado
                      valor={"05"}
                      valorSelecionado={diaCobranca}
                      titulo={"05"}
                      onClick={alterarDiaCobranca}
                    />

                    <ChipCustomizado
                      valor={"10"}
                      valorSelecionado={diaCobranca}
                      titulo={"10"}
                      onClick={alterarDiaCobranca}
                    />

                    <ChipCustomizado
                      valor={"20"}
                      valorSelecionado={diaCobranca}
                      titulo={"20"}
                      onClick={alterarDiaCobranca}
                    />

                    <ChipCustomizado
                      valor={"25"}
                      valorSelecionado={diaCobranca}
                      titulo={"25"}
                      onClick={alterarDiaCobranca}
                    />
                  </Linha>
                </>
              )}
              <Linha style={{ marginTop: "16px", justifyContent: "flex-end" }}>
                <BotaoVermelhoVazado
                  texto={t("buttons.cancel")}
                  tamanho="SM"
                  onClick={() => fechar()}
                />
                <BotaoVerdePreenchido
                  texto={t("buttons.save")}
                  tamanho="SM"
                  onClick={() => salvarConfiguracao(fechar)}
                />
              </Linha>
            </Coluna>
          )
        }
      />
    );
  }

  function BotaoModalCancelarRecorrenciaExtras() {
    const [quantidadeExtras, setQuantidadeExtras] = useState(0);

    function cancelarRecorrenciasExtras(fecharModal) {
      if (pagamentoNecessario) return;
      const itemExtra = {
        tipoItemPlanoWaybe: "SESSAO_EXTRA",
        quantidadeRecorrenciaCancelada: quantidadeExtras,
      };

      del("contrato/consumidor/waybe/empresa-contrato/item/extra/por-tipo", itemExtra)
        .then((response) => {
          if (response.status === 200) {
            toast.info(tPagamento("messages.recurrenceCancelled"));
            buscarDados();
          } else {
            toast.error(tPagamento("messages.cancelRecurrenceError"));
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error(tPagamento("messages.cancelRecurrenceError"));
        })
        .finally(() => {
          setQuantidadeExtras(0);
          fecharModal();
        });
    }

    const styleDesabilitado = desabilitadoSessao
      ? {
          pointerEvent: "none",
          // backgroundColor: tema.cores.actionDisable,
          color: tema.cores.textActionDisable,
          // border: `1px solid ${tema.cores.actionDisable}`,
          cursor: "auto",
        }
      : {};

    return (
      <GerarModalConfirmacao
        disabled={desabilitadoSessao}
        trigger={
          <BotaoVermelhoSemFundo
            texto={t("buttons.cancel")}
            tamanho="SM"
            style={{
              ...{ minWidth: "150px", padding: "0px 0px" },
              ...styleDesabilitado,
            }}
          />
        }
        titulo={tPagamento("extras.cancelExtraSessions")}
        botaoCancelar={(fechar) => (
          <BotaoVermelhoVazado texto={t("buttons.cancel")} tamanho="MD" onClick={fechar} />
        )}
        botaoConfirmar={(fechar) => (
          <BotaoVermelhoPreenchido
            texto={t("buttons.confirm")}
            tamanho="MD"
            onClick={() => cancelarRecorrenciasExtras(fechar)}
          />
        )}
        campoInput={
          <CampoDeInputNumericoComSetas
            width="100%"
            label={tPagamento("extras.quantity")}
            value={quantidadeExtras}
            onChange={(e) => setQuantidadeExtras(e)}
          />
        }
      />
    );
  }

  function PaginaInformacoesGerais() {
    const { largura, altura } = useTamanhoTela();

    useEffect(() => {
      tornarSlider(refSlider.current);
    }, [largura, altura]);

    return loading ? (
      <Carregando />
    ) : (
      <div style={{ pointerEvents: pagamentoNecessario ? "all" : "all" }}>
        <NomeEmpresa>
          {tPagamento("general.integrator", {
            name: informacoes?.integrador || tPagamento("general.notFound"),
          })}
        </NomeEmpresa>
        <ContainerCards ref={refSlider}>
          <Card
            titulo={tituloCardFactory(tPagamento("informationCards.generalInformation"))}
            footer={
              <LinhaBotoesInformacoesGerais>
                <BotaoModalConfigurarContrato
                  informacoesGerais={informacoes}
                  recorrenciaAtual={informacoes.recorrencia}
                />
                {possuiContratosParaCancelar && <BotaoModalCancelarRecorrencias />}
              </LinhaBotoesInformacoesGerais>
            }
          >
            <ItemCard
              titulo={tPagamento("informationCards.startOfContract")}
              conteudo={formatarDataParaPadraoBrasileiro(informacoes.dataInicioContrato)}
            />
            <ItemCard
              titulo={tPagamento("informationCards.contractDueDate")}
              conteudo={formatarDataParaPadraoBrasileiro(informacoes.dataVencimentoContrato)}
            />
            <ItemCard
              titulo={tPagamento("informationCards.recurrence")}
              conteudo={formatarRecorrencia(informacoes.recorrencia)}
            />
          </Card>

          <Card
            titulo={tituloCardFactory(
              tPagamento("general.payment"),
              informacoes.statusPagamento.cor,
              informacoes.statusPagamento.descricao,
            )}
          >
            {informacoes.tipoFaturamentoPlataforma != "BOLETO_BANCARIO" ? (
              <Fragment>
                <ItemCardMonetario
                  titulo={tPagamento("informationCards.totalValue")}
                  conteudo={informacoes.valorTotal}
                  corConteudo={corVerdeDinheiro()}
                />
                <ItemCardMonetario
                  titulo={tPagamento("informationCards.extrasValue")}
                  conteudo={informacoes.valorExtras}
                  corConteudo={corVerdeDinheiro()}
                />
              </Fragment>
            ) : (
              <></>
            )}
          </Card>

          <Card
            titulo={tituloCardSessoesExtras(tPagamento("informationCards.session"))}
            footer={footerCardSessao()}
          >
            <ItemCard
              titulo={tPagamento("informationCards.sessions")}
              conteudo={informacoes.sessoesExtras.quantidadeSessoesPlano}
            />
            <ItemCard
              titulo={tPagamento("informationCards.extraSessions")}
              conteudo={informacoes.sessoesExtras.quantidadeSessoesExtras}
            />
            <ItemCard
              titulo={tPagamento("informationCards.total")}
              conteudo={informacoes.sessoesExtras.total}
            />
          </Card>
        </ContainerCards>

        <div style={{ marginTop: "44px" }}>
          <TabelaLib dadosTabela={dadosTabela} variante={{ ordenacao: false }} />
        </div>
      </div>
    );
  }

  function irParaInformacoesGerais() {
    setPaginaAtiva(PAGINA_INFORMACOES_GERAIS);
  }

  function PaginaPagamento({ dadosPagamento }) {
    return (
      <RealizarPagamento
        titulo={dadosPagamento.titulo}
        listaTotal={dadosPagamento.listaTotal}
        listaDetalhes={dadosPagamento.listaDetalhes}
        avisoAntesPagamento={dadosPagamento.avisoAntesPagamento}
        realizarPagamentoFuncao={dadosPagamento.realizarPagamentoFuncao}
        voltarParaTelaAnterior={irParaPlanosDisponiveis}
      />
    );
  }

  function irParaPaginaPagamento(dadosPagamento) {
    setDadosPagamento(dadosPagamento);
    setPaginaAtiva(PAGINA_PAGAMENTO);
  }

  function PlanosDisponiveis() {
    return (
      <PlanosCompra
        comparacao={false}
        voltar={irParaInformacoesGerais}
        irParaPagamento={irParaPaginaPagamento}
        modoReduzido
        aplicacaoSelecionada={aplicacaoSelecionadaGlobal}
      />
    );
  }

  function irParaPlanosDisponiveis() {
    setPaginaAtiva(PAGINA_PLANOS_DISPONIVEIS);
  }

  function getPaginaAtiva() {
    switch (paginaAtiva) {
      case PAGINA_PAGAMENTO:
        return <PaginaPagamento dadosPagamento={dadosPagamento} />;
      case PAGINA_PLANOS_DISPONIVEIS:
        return <PlanosDisponiveis />;
      case PAGINA_INFORMACOES_GERAIS:
        return <PaginaInformacoesGerais />;
    }
  }

  return getPaginaAtiva();
}
